import utilsApi from '../assets/js/utils'

import ajax from '../assets/js/axios.config'


export default utilsApi.creatApi({
    // 获取最新Top推荐
    // getSteamData: ['post', ajax.v5ApiUrl + '/GetSteamInfo2022'],
    // getPsnData: ['post', ajax.v5ApiUrl + '/GetPsnInfo2022'],
    // getXboxData: ['post', ajax.v5ApiUrl + '/GetXblInfo2022'],
    getSteamData: ['post',  '/GetSteamInfo2024'],
    getPsnData: ['post',  '/GetPsnInfo2024'],
    getXboxData: ['post',  '/GetXblInfo2024'],
}); 